module.exports = __webpack_public_path__ + "img/accordian.46723453.svg";